import { BaseComponent } from '../../base-component';

export const ALTERNATIVE_URL_FRAGMENT = 'alternative';
export const VARIATION_LOAD_FAILED_EVENT = 'ft5.pdp.variation-load-failed';

export class RedirectMessageComponent extends BaseComponent {
    public rootSelector = '.js_pdp_redirect-message';
    constructor() {
        super();
    }
    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }
        this.handleSeoRedirect();
    }
    private showMessage(): void {
        this.getRootElement().innerHTML = `<oc-banner-v1 variant="warning" size="100">
            <strong>Deinen gewünschten Artikel können wir leider nicht mehr liefern.</strong>
        <br>Hier findest du einen Artikel, der dir auch gefallen könnte.
        </oc-banner-v1>`;
        this.getRootElement().classList.remove('pl_hidden');
    }

    private handleSeoRedirect(): void {
        if (o_util.fragment.get(ALTERNATIVE_URL_FRAGMENT)) {
            this.showMessage();
            o_util.fragment.remove(ALTERNATIVE_URL_FRAGMENT);
        }
    }
}
